/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Aside_Reply_TitleInputs */

const en_contact_aside_reply_title = /** @type {(inputs: Contact_Aside_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A person answers`)
};

const pl_contact_aside_reply_title = /** @type {(inputs: Contact_Aside_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiada człowiek`)
};

/**
* | output |
* | --- |
* | "A person answers" |
*
* @param {Contact_Aside_Reply_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside_reply_title = /** @type {((inputs?: Contact_Aside_Reply_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Aside_Reply_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside_reply_title(inputs)
	return en_contact_aside_reply_title(inputs)
});